import React, { useRef, useState, useEffect } from 'react';
import { SelectedColor } from './components/SelectedColor';
import { ColorPalette } from './components/ColorPalette';

interface ColorSelectProps {
  value?: string;
  onChange?: (color: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const ColorSelect: React.FC<ColorSelectProps> = ({
  value = '#000000',
  onChange,
  placeholder = 'Chọn màu...',
  className = '',
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedColor, setSelectedColor] = useState(value);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSelectedColor(value);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };

  const handleSelectColor = (color: string) => {
    setSelectedColor(color);
    if (onChange) {
      onChange(color);
    }
    setIsOpen(false);
  };

  return (
    <div className='relative w-full' ref={dropdownRef}>
      <SelectedColor
        selectedColor={selectedColor}
        placeholder={placeholder}
        className={className}
        toggleDropdown={!disabled ? toggleDropdown : undefined}
        disabled={disabled}
      />
      <ColorPalette isOpen={isOpen} selectedColor={selectedColor} handleSelectColor={handleSelectColor} />
    </div>
  );
};

export default ColorSelect;
